import { HeadingPages } from '../../../components/HeadingPages'
import { Box, Flex, Text } from '@chakra-ui/react'
import React, { useEffect } from 'react'
import { api } from '../../../services/api'
import { Filtro } from './Filtro'
import { Contadores } from './Contadores'
import { TableScreen } from './TableScreen'
import { useQuery } from 'react-query'
import { useSearchParams } from 'react-router-dom'

async function getInfoSolicitacaoLayout(data) {
  const response = await api.get(`/site/v2/fluxo-layout/listar-info-solicitacao-layout/${data.numero_nota}`)

  let orderByDate = response.data.lista.sort((a, b) => {
    if (a.prioridade && !b.prioridade) {
      return -1
    }
    if (!a.prioridade && b.prioridade) {
      return 1
    }

    return parseInt(a.prazo_entrega) - parseInt(b.prazo_entrega)
  })

  if (data.layout_antigo) {
    const responseAntigo = await api.get(`/site/v2/fluxo-layout/listar-info-solicitacao-layout/${data.layout_antigo}`)

    const orderByDateAntigo = responseAntigo.data?.lista?.sort((a, b) => {
      //se for prioridade vem primeiro (variavel prioridade), se não vem em ordem de prazo_entrega (string numero)

      if (a.prioridade && !b.prioridade) {
        return -1
      }
      if (!a.prioridade && b.prioridade) {
        return 1
      }

      return parseInt(a.prazo_entrega) - parseInt(b.prazo_entrega)
    })

    orderByDate = [...orderByDate, ...orderByDateAntigo]
  }

  const { controle_layout } = response.data

  return {
    data: orderByDate,
    controleLayout: controle_layout,
  }
}

export function SolicitacaoLayout() {
  const [searchParams] = useSearchParams()

  const { data: { data = [], controleLayout } = {}, refetch } = useQuery({
    queryKey: ['info-solicitacao-layout', searchParams.get('numero_nota'), searchParams.get('layout_antigo')],
    queryFn: () =>
      getInfoSolicitacaoLayout({
        numero_nota: searchParams.get('numero_nota') ?? '',
        layout_antigo: searchParams.get('layout_antigo') ?? '',
      }),
  })

  useEffect(() => {
    document.title = `${data?.length ?? 0} Pedidos - CRM Innovation Brindes`
  }, [data])

  return (
    <>
      <HeadingPages name="Solicitação de Layout" />

      <Filtro getInfoSolicitacaoLayout={getInfoSolicitacaoLayout} />

      <Box maxW="100%" px="2rem" mx="auto" mt={'1rem'} w="100%">
        <Flex marginLeft="1rem" marginBottom="1rem" gap={2} alignItems="center" justifyContent="space-between">
          <Contadores data={data} controleLayout={controleLayout} />
        </Flex>
        <TableScreen data={data} />
      </Box>
    </>
  )
}
